export enum StorageKeys {
  Language = '@liv-login:lang',
  HubSignIn = '@liv-login:hub-sign-in'
}
